import type { FaireProductEntity } from "../../entity_types/product";

export const p_8sjk9zk8yp: FaireProductEntity = {
  token: "p_8sjk9zk8yp",
  type: "product",
  name: "3n1 Display Kit - 3PC Grid Panel Sales Floor Display -",
  brandToken: "b_c5the2m9ad",
  brandName: "St. Louis Wholesale LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/f6c523ca79ebac089185dab267526751e88dd0086e6300aaa9730306ffe2c403.jpeg",
  galleryImageUrls: [],
  priceDollars: 15,
  description:
    '3n1 Display Kit - 3PC Grid Panel Sales Floor Display - Measures 64"x27" On Rollers - Caster Base Mesures 16" ',
  tags: [],
  msrpDollars: 45.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:17.658Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
